module.exports = __webpack_public_path__ + "assets/fonts/check-badge.ce54298f.svg";